import { productApiUrl } from "API/urls/product.api";
import { axiosInstance } from "configs/axios";

export const updateProductsApi = async (payload) => {
  try {
    const response = await axiosInstance.post(productApiUrl.updateProduct, {
      ...payload,
    });
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
